// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1XeLB","question":"Question_question__RK_4L","description":"Question_description__vZ9Is"};